// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"769":"64140342","2299":"64140342","2587":"5cc8484f","3550":"5590196c","5617":"d4b4c205","6493":"64140342","7035":"5cc8484f","7761":"64140342","7866":"5cc8484f","9727":"64140342"}[chunkId] + ".chunk.css";
};